import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-qr-asset-details',
  templateUrl: './dialog-qr-asset-details.component.html',
  styleUrls: ['./dialog-qr-asset-details.component.scss']
})
export class DialogQrAssetDetailsComponent implements OnInit {
  ngOnInit(): void {
    console.log('DATA', this.data);

  }
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<DialogQrAssetDetailsComponent>) { }

  onClick() {
    this.dialogRef.close();
  }


}
